// Adaptive feel-logging: one tap for energy + mood (~2s); flags expand only
// when something's off (brief §9).
export interface Feel {
  energy: number | null;
  mood: number | null;
  flags: { weak?: boolean; pain?: boolean; off?: boolean };
}

const FLAGS: { key: keyof Feel["flags"]; label: string }[] = [
  { key: "weak", label: "Weak" },
  { key: "pain", label: "Pain" },
  { key: "off", label: "Off" },
];

function Dots({ value, onPick }: { value: number | null; onPick: (n: number) => void }) {
  return (
    <div class="dots">
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} class={value === n ? "on" : ""} onClick={() => onPick(n)}>{n}</button>
      ))}
    </div>
  );
}

export function FeelLogger({ feel, onChange }: { feel: Feel; onChange: (f: Feel) => void }) {
  return (
    <div>
      <div class="feel">
        <span class="lbl">Energy</span>
        <Dots value={feel.energy} onPick={(n) => onChange({ ...feel, energy: n })} />
      </div>
      <div class="feel">
        <span class="lbl">Mood</span>
        <Dots value={feel.mood} onPick={(n) => onChange({ ...feel, mood: n })} />
      </div>
      <div class="flag-row">
        {FLAGS.map((f) => (
          <button
            key={f.key}
            class={feel.flags[f.key] ? "on" : ""}
            onClick={() => onChange({ ...feel, flags: { ...feel.flags, [f.key]: !feel.flags[f.key] } })}
          >
            {f.label}
          </button>
        ))}
      </div>
    </div>
  );
}
